var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFarmsMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 500 500",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.0596 177.859L96.8855 235.654L7.9303 207.264L67.0596 177.859Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M302.633 445.465L337.757 390.734L357.655 481.968L302.633 445.465Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M416.596 107.656L351.632 104.594L420.689 41.7489L416.596 107.656Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M430.936 149.224C457.133 195.233 464.811 251.604 447.481 305.9C429.426 362.504 387.888 405.189 337.075 426.757L344.128 459.094C405.972 434.754 456.814 383.898 478.541 315.799C499.542 249.993 489.02 181.59 455.522 126.843L430.936 149.224Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3528 150.675C133.852 70.9072 229.934 30.6023 320.239 59.4122C342.285 66.4514 362.213 77.0611 379.629 90.3847L404.056 68.1641C382.677 50.9071 357.858 37.2061 330.152 28.3672C222.662-5.92898 108.206 43.7663 57.8143 140.617L89.3528 150.675Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M260.616 442.403C240.877 442.417 220.805 439.442 201.022 433.129C110.717 404.319 55.7243 315.813 65.6372 225.015L34.0987 214.957C19.0914 323.114 83.6344 429.907 191.124 464.188C216.581 472.316 242.416 475.669 267.713 474.87L260.616 442.403Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M261.777 137.511C201.559 137.511 152.56 186.51 152.56 246.728C152.56 306.945 201.559 355.944 261.777 355.944C321.995 355.944 370.994 306.945 370.994 246.728C370.994 186.51 321.995 137.511 261.777 137.511ZM275.58 304.594L275.58 323.869L257.046 323.869L257.046 305.915C244.375 305.349 232.082 301.938 224.897 297.773L230.572 275.654C238.526 280.008 249.672 283.97 261.951 283.97C272.735 283.97 280.108 279.805 280.108 272.243C280.108 265.059 274.056 260.516 260.064 255.784C239.832 248.977 226.029 239.529 226.029 221.183C226.029 204.536 237.757 191.503 257.989 187.526L257.989 169.558L276.523 169.558L276.523 186.205C289.194 186.771 297.699 189.427 303.94 192.446L298.453 213.81C293.533 211.735 284.839 207.381 271.211 207.381C258.918 207.381 254.956 212.678 254.956 217.961C254.956 224.202 261.574 228.164 277.641 234.217C300.152 242.156 309.208 252.562 309.208 269.572C309.223 286.423 297.321 300.806 275.58 304.594Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M261.777 97.9029C179.585 97.9029 112.952 164.536 112.952 246.728C112.952 328.919 179.585 395.552 261.777 395.552C343.969 395.552 410.602 328.919 410.602 246.728C410.602 164.536 343.969 97.9029 261.777 97.9029ZM261.777 372.258C192.546 372.258 136.232 315.944 136.232 246.713C136.232 177.482 192.546 121.169 261.777 121.169C331.008 121.169 387.322 177.482 387.322 246.713C387.322 315.944 330.993 372.258 261.777 372.258Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmsMenu);
export default __webpack_public_path__ + "static/media/farmsMenu.a3f8873d31abd27c0e8f47b7d0679c92.svg";
export { ForwardRef as ReactComponent };